import { BookOpen } from 'lucide-react'

interface JournalLine {
  dtLabel: string
  ctLabel: string
  amount: string
}

interface JournalPreviewProps {
  lines: JournalLine[]
}

export function JournalPreview({ lines }: JournalPreviewProps) {
  if (lines.length === 0) return null

  return (
    <div className="rounded-md border border-neutral-200 bg-white">
      <div className="flex items-center gap-1.5 border-b border-neutral-200 px-3 py-1.5">
        <BookOpen className="h-3.5 w-3.5 text-neutral-400" />
        <span className="text-[11px] font-medium uppercase tracking-wide text-neutral-400">
          Journal Preview
        </span>
      </div>
      <div className="divide-y divide-neutral-100">
        {lines.map((line, i) => (
          <div key={i} className="flex items-center gap-3 px-3 py-1.5 text-sm font-mono">
            <span className="text-neutral-500">
              <span className="text-[10px] font-sans uppercase text-neutral-400">DT</span>{' '}
              {line.dtLabel}
            </span>
            <span className="text-neutral-300">/</span>
            <span className="text-neutral-500">
              <span className="text-[10px] font-sans uppercase text-neutral-400">CT</span>{' '}
              {line.ctLabel}
            </span>
            <span className="ml-auto font-medium text-neutral-900">
              {line.amount}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
